export default __webpack_public_path__ + "static/media/sweets-16.78a264e9.png";